// extracted by mini-css-extract-plugin
export default {"aboutUs":"AboutUs_aboutUs__Sjh+M","itemCenter":"AboutUs_itemCenter__MyQuq","row":"AboutUs_row__p-YYy","column":"AboutUs_column__1KQj4"};